import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { ICreateAvaliacaoOrdemCompraColetaUseCase } from "../../../presentation/useCases/create/create_avaliacao_ordem_compra_coleta_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateAvaliacaoOrdemCompraColetaUseCase
 */

export class CreateAvaliacaoOrdemCompraColetaUseCase implements ICreateAvaliacaoOrdemCompraColetaUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createAvaliacaoOrdemCompraColeta(
    idOrdemCompra: number,
    nroNotaFiscal: string | null,
    dataEntrega: Date,
    arquivo: File | null,
    produtosServicos: {
      idProdutoServico: number;
      quantidadeRecebida: number | null;
      quantidadeRestante: number | null;
    }[],
    registrarEntradaEstoque: boolean,
  ): Promise<void> {
    produtosServicos.forEach(x => {
      if (x.quantidadeRecebida !== null) {
        if (x.quantidadeRestante === null) {
          throw new UserFriendlyError('Quantidade restante é obrigatória para todos os produtos/serviços!');
        }
        if (x.quantidadeRecebida > x.quantidadeRestante) {
          throw new UserFriendlyError('Quantidade recebida não pode ser maior que a quantidade restante!');
        }
      }
    });

    await this.repository.createAvaliacaoOrdemCompraColeta(
      idOrdemCompra,
      nroNotaFiscal,
      dataEntrega,
      arquivo,
      produtosServicos,
      registrarEntradaEstoque,
    );
  }
}
